<mat-form-field color="accent" class="full-width-form" subscriptSizing="dynamic">
	<mat-label>{{ T.ASSESSMENT_EXAMINER_NOTE | translate }}</mat-label>
	<textarea
		matInput
		cdkTextareaAutosize
		[disabled]="mode !== AssessablePanelMode.Answer"
		[rows]="12"
		[ngModel]="note"
		(ngModelChange)="noteChange.emit($event)"
		[cdkAutosizeMaxRows]="15"
	></textarea>
</mat-form-field>
